import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Anchor, BookOpen, MapPin } from "lucide-react";
import { colors, fonts, TAB_BAR_HEIGHT, APP_MAX_WIDTH } from "../theme";

const TABS = [
  { to: "/", label: "Home", Icon: Anchor, exact: true },
  { to: "/menu", label: "Menu", Icon: BookOpen },
  { to: "/info", label: "Info", Icon: MapPin },
];

export default function BottomTabs() {
  const location = useLocation();

  return (
    <nav
      style={{
        position: "fixed",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
        maxWidth: APP_MAX_WIDTH,
        height: TAB_BAR_HEIGHT,
        display: "flex",
        alignItems: "stretch",
        borderTop: `0.5px solid ${colors.border}`,
        backgroundColor: "rgba(5,8,15,0.9)",
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        zIndex: 100,
      }}
    >
      {TABS.map(({ to, label, Icon, exact }) => {
        const active = exact ? location.pathname === "/" : location.pathname.startsWith(to);
        const color = active ? colors.brandPrimary : colors.muted;
        return (
          <NavLink
            key={to}
            to={to}
            className="pm-link pm-press"
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
            }}
          >
            <Icon size={22} color={color} strokeWidth={1.75} />
            <span
              style={{
                fontFamily: fonts.body,
                fontSize: 11,
                letterSpacing: 0.6,
                textTransform: "uppercase",
                fontWeight: 500,
                color,
              }}
            >
              {label}
            </span>
          </NavLink>
        );
      })}
    </nav>
  );
}
